import {
  BannerData,
  CentreData,
  LocationData,
  PolygonData,
  TransactionsData,
  UserData,
} from "../../../../types/models/master/MasterApp";



export const bannerData: BannerData[] = [
  {
    id: 1,
    bannerType: "HomeBanner",
    title: "Broadband Internet-1 - Flat Free Plans",
    image : "1",
    index: "2",
    active:false,
    position:"top",
    uri:"tes",
  },
  
];
export const userData: UserData[] = [
  {
    id: 1,
    contactNo: "",
   CreatedOn: new Date(),
   email: "string",
   IsActive: false,
   password: "password",
   roleId: 3,
   SRCode: "string",
   username: "df"
  
  },
  
];


export const transactionsData: TransactionsData[] = [
  {
    id: 1,
    orderId: "2099771POTT2",
    txnId : "",
    txndate: "05/01/2025 04:07 PM",
    custId: "2099771",
    name: "MAYANK",
    rmn: "9634338572",
    type: "OTT",
    resMsg: "",
    wallet: "NO",
    refNo: "-",
    amount: "158.12",
    status:"Pending"
  },
  {
    id: 2,
    orderId: "2099771POTT1",
    txnId : "",
    txndate: "05/01/2025 04:07 PM",
    custId: "2099771",
    name: "MAYANK",
    rmn: "9634338572",
    type: "OTT",
    resMsg: "",
    wallet: "NO",
    refNo: "-",
    amount: "158.12",
    status:"Pending"
  },
  {
    id: 3,
    orderId: "2101494POTT1",
    txnId : "",
    txndate: "01/11/2024 10:11 AM",
    custId: "2101494",
    name: "RAJEEV KUMAR",
    rmn: "8630145752",
    type: "OTT",
    resMsg: "",
    wallet: "NO",
    refNo: "-",
    amount: "46.02",
    status:"Pending"
  },
];


export const locationData: LocationData[] = [
  {
    id: 1,
    sNo: "2",  
    deviceIp: "3",
    npCode: "3",
    npName: "3",
    latLng:"3",
    pinCode: "3",
    latitude: "3",
    longitude: "3",
    hostName: "3",
    serviceVlanid: "3",
    nasPortId:"3",
    voltage: "3",
    switchConnectivity: "3",
    switchPortNo: "3",
    switchPortConnectivity: "3",
    mediaConverter: "3",
    location:"3",
    distanceFromCo: "3",
    rowPowerRouter:"3",
    powerBackup: "3",
    backupOwnership: "3",
    distanceFromLink: "3",
    status: "3",
    mac:"3",
    makeModel:"3",
    deviceName:"3",
    batteryCapacity:"3",
    locationPowerLoad:"3",
    locationAddress:"3",
    distanceFromUplink:"3",
  },
  
];
export const centreData: CentreData[] = [
  {
    sNo: 1,
    categoryName:"Facing Connectivity Related Issues" ,
    parentCategory: "Parent Category",
    type: "	Complaint",
    status: "Active",
  },
  {
    sNo: 2,
    categoryName:"Have Billing/ Charges/ Usage Related Issues" ,
    parentCategory: "Parent Category",
    type: "	Complaint",
    status: "Active",
  },
  {
    sNo: 3,
    categoryName:"Need Assistance on Plan Change, Shifting/ Rewiring, Router, Security Refund, etc" ,
    parentCategory: "Parent Category",
    type: "Request",
    status: "Active",
  },
  {
    sNo: 4,
    categoryName:"Wish to review/ change Account Profile Details" ,
    parentCategory: "Parent Category",
    type: "	Request",
    status: "Active",
  },
  {
    sNo: 5,
    categoryName:"Wish to discontinue services" ,
    parentCategory: "Parent Category",
    type: "	Request",
    status: "Active",
  },
  {
    sNo: 6,
    categoryName:"Wish to discontinue services" ,
    parentCategory: "Parent Category",
    type: "	Request",
    status: "Active",
  },
  {
    sNo: 7,
    categoryName:"	Any Other Issue/ Assistance Required/ Query" ,
    parentCategory: "Parent Category",
    type: "	Request",
    status: "Active",
  },
  {
    sNo: 8,
    categoryName:"Refund Related Issue" ,
    parentCategory: "Parent Category",
    type: "	Request",
    status: "Active",
  },
  {
    sNo: 9,
    categoryName:"Installation and Shifting Related Issues ",
    parentCategory: "Parent Category",
    type: "	Complaint",
    status: "Active",
  },
]

export default bannerData;
